module.exports = __webpack_public_path__ + "img/psv-eindhoven.95ae6f9a.png";